import { ref } from 'vue'
import { defineStore } from 'pinia'
import { apiClientV1, type ApiError } from '@/ContextTab/services/apiClient'
import type { NewsRelationsGetOutReadable } from '@/api/generated/v1'


// новости, связанные с конкретной
export const useNewsItemRelationsStore = defineStore('newsItemRelations', () => {

  const newsRelations = ref<NewsRelationsGetOutReadable | null>(null)
  const isFetching = ref(false)
  const error = ref<ApiError[] | null>(null)

  async function loadRelationsNews(newsId: number) {
    isFetching.value = true

    try {
      const response = await apiClientV1.NewsService.getNewsByNewsIdRelations({
        path: {
          news_id: newsId,
        },
      })

      if (response.error) {
        error.value = response.error.errors
      } else {
        newsRelations.value = response.data ?? null
      }
    } finally {
      isFetching.value = false
    }
  }

  return {
    newsRelations,
    isFetching,
    error,

    loadRelationsNews,
  }
})
